import { useAuth } from 'components'
import SignInOrDemo from 'components/SignInOrDemo/SignInOrDemo'
import { generateAlternatesAndCanonical } from 'data/seo/seo'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PAGE } from 'utils/pages'

const SignInPage = ({ locale }) => {
  const router = useRouter()
  const { signInWithGoogleAccount, authUser, createDemoAccount } = useAuth()
  const [keepLoggedIn, setKeepLoggedIn] = useState(false)

  const { t } = useTranslation('signup')

  useEffect(() => {
    if (authUser) {
      if (authUser?.has_access_application & !authUser?.has_access_admin) {
        router.push(PAGE.wbsoAppDashboard)
      } else if (authUser?.has_access_admin) {
        router.push(PAGE.dashboard)
      } else {
        // User has no access to any protected pages
        message.error(
          'You do not have access to any protected pages. If you think this is an error, please contact support ( support@traqqie.com ).',
          { duration: 2500 },
        )
      }
    }
  }, [authUser])

  const handleSignIn = async () => {
    // try {
    const user = await signInWithGoogleAccount({ keepLoggedIn: keepLoggedIn })
    //   if (authUser?.has_access_application & !authUser?.has_access_admin) {
    //     router.push(PAGE.wbsoDashboard)
    //   } else if (authUser?.has_access_admin) {
    //     router.push(PAGE.dashboard)
    //   } else {
    //     // User has no access to any protected pages
    //     message.error(
    //       'You do not have access to any protected pages. If you think this is an error, please contact support (support@traqqie.com).',
    //       { duration: 2500 },
    //     )
    //   }
    // } catch (error) {
    //   console.error('Sign in error:', error)
    //   // Handle sign-in error (e.g., show an error message to the user)
    // }
  }

  return (
    <>
      <NextSeo
        title={t('sign_in_meta_title')}
        description={t('sign_in_meta_title')}
        openGraph={{
          title: t('sign_in_meta_title'),
          description: t('sign_in_meta_title'),
        }}
        languageAlternates={
          generateAlternatesAndCanonical(locale, 'sign-in').alternates
        }
        canonical={generateAlternatesAndCanonical(locale, 'sign-in').canonoical}
      />
      <SignInOrDemo
        handleSignIn={handleSignIn}
        handleDemoClick={createDemoAccount}
      />
    </>
  )
}

export default SignInPage
